import { Outlet } from 'react-router';
import { NavMenu } from './NavMenu';
import { TopBar } from './TopBar';

export function Layout() {
    return (
		<div className="sm:min-h-screen sm:h-screen sm:flex sm:min-w-screen sm:w-full max-h-screen">
			{/* <ShowSideBar> */}
			{/* </ShowSideBar> */}
			{/* <MobileNavBar /> */}
			<NavMenu />

			<div className="flex flex-col w-full overflow-hidden max-h-full h-screen panocha">
				<div className="h-14 flex-shrink-0">
					<TopBar />
				</div>

				<div className="flow-grow overflow-hidden max-h-full h-full">
					<Outlet />
				</div>
			</div>

		</div>
    );

}
